import React from "react"
import { Label } from "reactstrap"

export default ({ text }) => <Label>
    {text}
    <span className="text-danger">*</span>
</Label>